import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import MsgReducer from './MsgReducer';
import PresenceReducer from './PresenceReducer';
import NotesReducer from './NotesReducer';

const RootReducer = combineReducers({
  AppReducer,
  MsgReducer,
  PresenceReducer,
  NotesReducer,
});

export default RootReducer;
